import { CLOSE_ICON_TYPE, ICON_TYPES, WIDGET_TYPES } from 'enums/configuration';

export default {
  cohortId: null,
  config: {
    /*
      authenticatedTagName should only be used to track
      in Amplitude if user is logged in on our customer's
      website. It should be removed when we have an authenticated
      user chat flow.
    */
    abTestingPercentage: 0,
    attachmentsEnabled: false,
    alwaysShow: false,
    authenticatedTagName: undefined,
    border: {
      color: '',
      width: '0px',
    },
    borderRadius: 'LARGE',
    colors: {},
    closeButton: {
      iconType: CLOSE_ICON_TYPE.X_ICON,
      title: 'Close',
    },
    chatClosed: {
      message: `We want to chat with you, but it's outside of our office hours. Chat again tomorrow to pick up where we left off.`,
      title: `Whoops, sorry we missed you!`,
    },
    chatThrottled: {
      message:
        'We want to chat with you, but we are experiencing higher chat volumes than usual. Please visit our contact page for other ways to reach out to us.',
      title: 'Whoops, sorry we missed you!',
    },
    display: 'ALL_PAGES',
    dropshadowEnabled: true,
    font: "'Helvetica Neue', Helvetica, sans-serif",
    initialChatButton: {
      type: 'TEXT',
      value: 'Live Chat',
    },
    isDraggable: false,
    lng: undefined,
    minimizedChatButton: {
      title: 'Open chat',
    },
    onboarding: {
      authenticationError: 'An error occurred. Please try again.',
      blankFieldError: 'Both name and email are required.',
      enabled: true,
      header: "Let's Chat",
      introMessage: 'Hi there! Tell us a bit about yourself.',
      invalidEmailError: 'Please enter a valid email address.',
      nameField: 'Your name',
      emailField: 'Your email',
      submitButton: "Let's Go",
    },
    ongoingChat: {
      compositionPlaceholder: 'Write a message',
      endChatTitle: 'Chat has ended',
      endMessageAgentEnded:
        'Thanks for chatting <<USERNAME>>! More questions? Chat again to pick up where we left off.',
      endMessageTimeExpired:
        'Thanks for chatting <<USERNAME>>! More questions? Chat again to pick up where we left off.',
      endMessageConsumerNoReply: `We haven't heard from you in a while, <<USERNAME>>. Type another message to pick up where we left off.`,
      endMessageNewSessionStarted: `We noticed you have another active chat. You can send us a message to chat here, and we will end the other chat for you`,
      submitButtonTitle: 'Send message',
      title: "Let's Chat",
      welcomeMessage: 'Hello <<USERNAME>>! How can we help?',
    },
    selfService: {
      quickActions: [],
    },
    rules: {},
    widgetType: WIDGET_TYPES.CHAT,
    zIndex: 2147483000,

    // DEMO ONLY
    // DEPRECATED
    demoSelfServiceEnabled: false,
  },
  customText: {
    attachments: {
      genericErrorText: 'Sorry, we encountered a problem with your upload, please try another file.',
      fileSizeErrorText: 'Sorry, that file is too big, can you please try a smaller one?',
    },
    buttonText: 'Chat with an agent',
    inactiveButtonText: 'Talk to us',
    headerTitle: 'Hi, how can we help you?',
    searchPlaceholder: 'Search for answers',
    officeHourMessage: 'Sorry, we are unavailable at this time.',
    interactiveOnboarding: {
      autoResponse: 'Got it! Someone will be with you shortly.', // 4th message
      emailPrompt:
        "Thank you for contacting us.\n\nWhat's your email? We'll use your email to find your profile and any past conversations you've had with us - not to spam you.", // 1st message
      namePrompt: 'Thanks! Can we get your name?', // 2nd message
      onboardingSuccess: 'Thanks, <<USERNAME>>! How can we help?', // 3rd message
    },
    onboardingMessage:
      "Thank you for contacting us.\n\nWhat's your email? We'll use your email to find your profile and any past conversations you've had with us - not to spam you.",
    authenticationAutoResponse: 'Thanks! How can we help?',
    composition: {
      emailError: 'Please enter a valid email address',
      emailPrompt: 'Enter your email',
      nameError: 'Please enter a name that is less than 24 characters',
      namePrompt: 'Enter your name',
      messagePrompt: 'Write a message',
    },
  },
  icons: {
    [ICON_TYPES.ATTACHMENT_UPLOAD]: `<svg width="17" height="20" fill="none">
  <mask id="a" fill="#fff">
    <path fill-rule="evenodd" d="M3.136 3.85A2.314 2.314 0 0 0 .822 6.166v7.317a2.314 2.314 0 0 0 2.314 2.314h7.944a2.314 2.314 0 0 0 2.314-2.314V6.165A2.314 2.314 0 0 0 11.08 3.85H3.136zm0-.821A3.136 3.136 0 0 0 0 6.165v7.317a3.137 3.137 0 0 0 2.525 3.076 3.137 3.137 0 0 0 3.077 2.526h7.944a3.136 3.136 0 0 0 3.136-3.136V8.631a3.137 3.137 0 0 0-2.525-3.077A3.137 3.137 0 0 0 11.08 3.03H3.136zm11.08 3.386v7.067a3.136 3.136 0 0 1-3.136 3.136H3.386a2.315 2.315 0 0 0 2.216 1.644h7.944a2.314 2.314 0 0 0 2.314-2.314V8.631a2.315 2.315 0 0 0-1.644-2.216z" clip-rule="evenodd"/>
  </mask>
  <path fill="#fff" fill-rule="evenodd" d="M3.136 3.85A2.314 2.314 0 0 0 .822 6.166v7.317a2.314 2.314 0 0 0 2.314 2.314h7.944a2.314 2.314 0 0 0 2.314-2.314V6.165A2.314 2.314 0 0 0 11.08 3.85H3.136zm0-.821A3.136 3.136 0 0 0 0 6.165v7.317a3.137 3.137 0 0 0 2.525 3.076 3.137 3.137 0 0 0 3.077 2.526h7.944a3.136 3.136 0 0 0 3.136-3.136V8.631a3.137 3.137 0 0 0-2.525-3.077A3.137 3.137 0 0 0 11.08 3.03H3.136zm11.08 3.386v7.067a3.136 3.136 0 0 1-3.136 3.136H3.386a2.315 2.315 0 0 0 2.216 1.644h7.944a2.314 2.314 0 0 0 2.314-2.314V8.631a2.315 2.315 0 0 0-1.644-2.216z" clip-rule="evenodd"/>
  <path fill="#000" d="M2.525 16.558l.807-.159-.107-.54-.54-.107-.16.806zM14.157 5.554l-.807.16.107.54.54.107.16-.807zm.06.861l.237-.786-1.06-.32v1.106h.822zM3.386 16.618v-.822H2.28l.32 1.06.786-.238zM1.643 6.165c0-.824.668-1.492 1.492-1.492V3.029A3.136 3.136 0 0 0 0 6.165h1.644zm0 7.317V6.165H0v7.317h1.644zm1.492 1.492a1.492 1.492 0 0 1-1.492-1.492H0a3.136 3.136 0 0 0 3.136 3.136v-1.644zm7.944 0H3.136v1.644h7.944v-1.644zm1.492-1.492c0 .824-.668 1.492-1.492 1.492v1.644a3.136 3.136 0 0 0 3.136-3.136h-1.644zm0-7.317v7.317h1.644V6.165h-1.644zM11.08 4.673c.824 0 1.492.668 1.492 1.492h1.644a3.136 3.136 0 0 0-3.136-3.136v1.644zm-7.944 0h7.944V3.029H3.136v1.644zM.822 6.165A2.314 2.314 0 0 1 3.136 3.85V2.207A3.958 3.958 0 0 0-.822 6.165H.822zm0 7.317V6.165H-.822v7.317H.822zm1.863 2.27a2.315 2.315 0 0 1-1.863-2.27H-.822a3.959 3.959 0 0 0 3.188 3.883l.319-1.613zm-.966.966a3.959 3.959 0 0 0 3.883 3.188v-1.644c-1.123 0-2.06-.8-2.27-1.863l-1.613.319zm3.883 3.188h7.944v-1.644H5.602v1.644zm7.944 0a3.958 3.958 0 0 0 3.958-3.958H15.86a2.314 2.314 0 0 1-2.314 2.314v1.644zm3.958-3.958V8.631H15.86v7.317h1.644zm0-7.317a3.959 3.959 0 0 0-3.188-3.883l-.318 1.613a2.315 2.315 0 0 1 1.862 2.27h1.644zM11.08 3.85c1.123 0 2.06.8 2.27 1.862l1.613-.318a3.959 3.959 0 0 0-3.883-3.188V3.85zm-7.944 0h7.944V2.207H3.136V3.85zm10.258 2.564v7.067h1.644V6.415h-1.644zm0 7.067a2.314 2.314 0 0 1-2.314 2.314v1.644a3.958 3.958 0 0 0 3.958-3.958h-1.644zm-2.314 2.314H3.386v1.644h7.694v-1.644zM5.602 17.44a1.493 1.493 0 0 1-1.429-1.06l-1.573.475a3.137 3.137 0 0 0 3.002 2.229V17.44zm7.944 0H5.602v1.644h7.944V17.44zm1.492-1.492c0 .824-.668 1.492-1.492 1.492v1.644a3.136 3.136 0 0 0 3.136-3.136h-1.644zm0-7.317v7.317h1.644V8.631h-1.644zm-1.06-1.429c.615.186 1.06.756 1.06 1.429h1.644c0-1.418-.94-2.613-2.228-3.002l-.475 1.573z" mask="url(#a)"/>
  <path fill="#000" fill-rule="evenodd" d="M7.138 1c.284 0 .513.23.513.513v.564h1.026v-.539a1.538 1.538 0 1 0-3.077 0v6.924a1.538 1.538 0 1 0 3.077 0V5.538H7.65v2.95a.513.513 0 0 1-1.025 0V1.512c0-.283.23-.513.512-.513z" clip-rule="evenodd"/>
</svg>
`,
    [ICON_TYPES.ATTACHMENT_CLOSE]: `<svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 1L5 5" stroke="black" stroke-width="0.571429" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M5 1L1 5" stroke="black" stroke-width="0.571429" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    `,
    [ICON_TYPES.CHAT]: `<svg width="17" height="15" viewBox="0 0 17 15" fill="none">
      <path
        d="M1.09412 13.7055C0.9968 13.8947 1.02987 14.1247 1.17655 14.2789C1.32323 14.433 1.55139 14.4774 1.74518 14.3896L5.70854 12.593C6.4873 12.8069 7.321 12.9228 8.1875 12.9228C12.3204 12.9228 15.875 10.2422 15.875 6.71139C15.875 3.17993 12.3204 0.5 8.1875 0.5C4.05464 0.5 0.5 3.17993 0.5 6.71139C0.5 8.35426 1.28476 9.82693 2.52775 10.9184L1.09412 13.7055Z"
        strokeLinejoin="round"
      />
    </svg>`,
    [ICON_TYPES.EXTERNAL_LINK]: `<svg width="19" height="12" viewBox="0 0 19 12" fill="none" tabIndex="-1">
      <path
        d="M18.4906 3.60004H10.0002C8.23303 3.60004 6.80023 5.03364 6.80023 6.80004V8.40004"
        stroke="#979797"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.2906 6.80002L18.4906 3.60002L15.2906 0.400024"
        stroke="#979797"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6 6.40002V9.60002C11.6 10.7046 10.7046 11.6 9.59999 11.6H2.39999C1.29542 11.6 0.399994 10.7046 0.399994 9.60002V2.40002C0.399994 1.29545 1.29542 0.400024 2.39999 0.400024H10.4C11.0627 0.400024 11.6 0.937283 11.6 1.60002V1.60002"
        stroke="#979797"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>`,
    [ICON_TYPES.INTERNAL_LINK]: `<svg width="7" height="13" viewBox="0 0 7 13" fill="none" tabIndex="-1">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.146447 0.146447C0.341709 -0.0488155 0.658291 -0.0488155 0.853553 0.146447L6.85355 6.14645C7.04882 6.34171 7.04882 6.65829 6.85355 6.85355L0.853553 12.8536C0.658291 13.0488 0.341709 13.0488 0.146447 12.8536C-0.0488155 12.6583 -0.0488155 12.3417 0.146447 12.1464L5.79289 6.5L0.146447 0.853553C-0.0488155 0.658291 -0.0488155 0.341709 0.146447 0.146447Z"
        fill="#999999"
      />
    </svg>`,
    [ICON_TYPES.SEARCH]: `<svg viewBox="0 0 512 512">
      <path
        fill="currentColor"
        d="M508.5 481.6l-129-129c-2.3-2.3-5.3-3.5-8.5-3.5h-10.3C395 312 416 262.5 416 208 416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c54.5 0 104-21 141.1-55.2V371c0 3.2 1.3 6.2 3.5 8.5l129 129c4.7 4.7 12.3 4.7 17 0l9.9-9.9c4.7-4.7 4.7-12.3 0-17zM208 384c-97.3 0-176-78.7-176-176S110.7 32 208 32s176 78.7 176 176-78.7 176-176 176z"
      />
    </svg>`,
  },
  theme: {
    borderRadius: 'LARGE',
    colors: {
      alert: '#FE1A20',
      attachmentBackground: '#312E2E',
      brandPrimary: '#f3f3f3',
      brandSecondary: '#ffffff',
    },
    dropshadowEnabled: true,
    fontLibrary: {
      primary: 'Helvetica Neue, Helvetica, sans-serif',
      secondary: 'Helvetica Neue, Helvetica, sans-serif',
    },
  },
};
